import React, { FC, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
	DeviceType,
	Orientation,
	RangeSettings,
	SofaRangeName,
	VisibleModal,
	WriteDirection,
	YmalSectionType,
	YmalType,
} from 'sofa-reborn-react';
import { IDexfSettings, IProduct, ITranslations } from '@inter-ikea-kompis/types';
import { RootState, AppDispatch } from '../store';
import { ymalPipLinkClick } from '../store/checkout/actions';
import YmalView from '../components/YmalView';
import { SummaryPageTabEnum } from '@inter-ikea-kompis/component-summary-page';
import { IProductShelfVisibleModal } from '@inter-ikea-kompis/component-product-shelf';
import { ProductCardModalEnum } from '@inter-ikea-kompis/component-product-card';

const YmalViewContainer: FC<{
	ymalProducts: IProduct[] | [];
	selectedIndex: number | undefined;
	showYmalContainer: boolean;
	selectedTab: SummaryPageTabEnum;
	showAdditionalCoverCard?: boolean;
	onYmalAddToCart: (
		e: CustomEvent,
		types: { ymalType: YmalType; ymalSectionType: YmalSectionType }
	) => void;
	onYmalAddToList: (
		e: CustomEvent,
		types: { ymalType: YmalType; ymalSectionType: YmalSectionType }
	) => void;
	onModalOpen: (e: CustomEvent) => void;
	onModalClose: () => void;
	onAdditionalCoverClick: () => void;
}> = (props) => {
	const deviceType = useSelector<RootState, DeviceType>((state) => state.deviceInfo.deviceType);
	const orientation = useSelector<RootState, Orientation>((state) => state.deviceInfo.orientation);
	const writeDirection = useSelector<RootState, WriteDirection>(
		(state) => state.localization.writeDirection
	);
	const kompisSettings = useSelector<RootState, IDexfSettings | null>(
		(state) => state.settings.kompisSettings
	);
	const kompisTranslations = useSelector<RootState, ITranslations | null>(
		(state) => state.localization.kompisTranslations
	);
	const rangeSettings = useSelector<RootState, RangeSettings>(
		(state) => state.settings.rangeSettings as RangeSettings
	);
	const visibleModal = useSelector<RootState, VisibleModal | null>(
		(state) => state.checkout.visibleModal
	);
	const dispatch = useDispatch<AppDispatch>();
	const kompisVisibleModal: IProductShelfVisibleModal = {
		itemId: visibleModal?.itemId ?? '',
		modal: visibleModal?.modal as ProductCardModalEnum,
	};

	const [selectedYmalIndex, setSelectedYmalIndex] = useState(0);

	const onYmalPipLinkClick = (e: CustomEvent): void => {
		const id = e.detail.content.itemNoGlobal || e.detail.content.itemNoLocal;
		dispatch(ymalPipLinkClick(id));
	};

	const onChange = (e: CustomEvent): void => {
		setSelectedYmalIndex(e.detail.selectedIndex);
	};

	return (
		<YmalView
			deviceType={deviceType}
			orientation={orientation}
			writeDirection={writeDirection}
			kompisSettings={kompisSettings}
			kompisTranslations={kompisTranslations}
			selectedTab={props.selectedTab}
			selectedIndex={selectedYmalIndex}
			ymalProducts={props.ymalProducts}
			visibleModal={kompisVisibleModal}
			sofaRangeName={rangeSettings.rangeName as SofaRangeName}
			showAdditionalCover={props.showAdditionalCoverCard ? true : false}
			showYmalContainer={props.showYmalContainer}
			onChange={onChange}
			onYmalPipLinkClick={onYmalPipLinkClick}
			onYmalAddToCart={props.onYmalAddToCart}
			onYmalAddToList={props.onYmalAddToList}
			onModalOpen={props.onModalOpen}
			onModalClose={props.onModalClose}
			onAdditionalCoverClick={props.onAdditionalCoverClick}
		/>
	);
};
export default YmalViewContainer;
